var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success-seminar"},[_c('div',{staticClass:"success-seminar__wrap"},[_c('h2',{staticStyle:{"text-transform":"none","margin-top":"14px","text-align":"center"}},[_vm._v(" "+_vm._s(_vm.$t('ourTrainingEventsAreAConcentrationOfInformationAndAnIncredibleAtmosphere'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }